import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 7px;
  margin-top: 10px;
`;

export const Tag = styled.div`
  display: grid;
  place-items: center;
  height: 30px;
  padding: 0 10px;
  border-radius: 20px;
  background-color: var(--grey-2);
  font-size: 13px;
  color: var(--grey-6);
`;
